import request from '@/utils/request'

/* 登录 */
export function requestLogin(data) {
    return request({
        url: '/sso/v1/auth/supplier/token',
        method: 'get',
        params: data
    })
}
export function requestPhone(data) {
    return request({
        url: '/saas/crm/supplier/phone',
        method: 'get',
        params: data
    })
}
export function requestUser(data) {
    return request({
        url: '/workorder/v1/system/current/user',
        method: 'get',
        params: data
    })
}

//工单分页
export function requestWorkOrderList(data) {
    return request({
        url: `/workorder/v1/supplier/workOrder/pages`,
        method: 'post',
        data
    })
}
//工单状态统计
export function requestWorkOrderStatus(data) {
    return request({
        url: `/workorder/v1/supplier/statistics`,
        method: 'post',
        data
    })
}

//工单创建
export function requestWorkOrderCreate(data) {
    return request({
        url: `/workorder/v1/supplier/workOrder/create`,
        method: 'post',
        data
    })
}
//工单详情
export function requestWorkOrderDetail(id) {
    return request({
        url: `/workorder//v1/workOrder/detail/${id}`,
        method: 'get'
    })
}
//查询所有租客
export function requestWorkOrderCustomer(data) {
    return request({
        url: `/workorder/v1/workOrder/customer/list`,
        method: 'get',
        params: data
    })
}
//查询所有供应商
export function requestWorkOrderSupplier(data) {
    return request({
        url: `/workorder/v1/supplier/customer/list`,
        method: 'get',
        params: data
    })
}
//查询工单房源
export function requestWorkOrderHouse(data) {
    return request({
        url: `/workorder/v1/workOrder/house/list`,
        method: 'get',
        params: data
    })
}
//查询工单服务类型
export function requestWorkOrderServiceType(data) {
    return request({
        url: `/workorder/v1/workOrder/service/type`,
        method: 'get',
        params: data
    })
}
//工单转单
export function requestWorkOrderZd(data) {
    return request({
        url: `/workorder/v1/supplier/zd/${data.workOrderId}`,
        method: 'get',
        params: data
    })
}
//工单接单
export function requestWorkOrderJd(workOrderId) {
    return request({
        url: `/workorder/v1/supplier/receive/${workOrderId}`,
        method: 'get'
    })
}
//工单处理
export function requestWorkOrderCl(workOrderId) {
    return request({
        url: `/workorder/v1/supplier/handle/${workOrderId}`,
        method: 'get'
    })
}
//工单完成
export function requestWorkOrderFinish(data) {
    return request({
        url: `/workorder/v1/supplier/finish`,
        method: 'post',
        data
    })
}
//工单添加备注
export function requestWorkOrderRemark(data) {
    return request({
        url: `/workorder/v1/supplier/add/remark/${data.id}`,
        method: 'get',
        params: data
    })
}
//添加协作人
export function requestWorkOrderCooperation(data) {
    return request({
        url: `/workorder/v1/supplier/add/cooperation`,
        method: 'post',
        data
    })
}
//删除协作人
export function requestWorkOrderCooperationD(data) {
    return request({
        url: `/workorder/v1/workOrder/remove/cooperation`,
        method: 'get',
        params: data
    })
}
// 获取七牛token
export function requestQiniuToken(data) {
    return request({
        url: `/workorder/v1/qiniu/token`,
        method: 'get',
        params: data
    })
}
//工单根据房源查房间
export function requestWorkOrderHouseRoom(houseId) {
    return request({
        url: `/workorder/v1/workOrder/rooms/${houseId}`,
        method: 'get'
    })
}
/* 钉钉授权 */
export function requestDDConfig(data) {
    return request({
        url: `/saas/crm/get/supplier/auth/info`,
        method: 'get',
        params: data
    })
}
// 获取工单服务类型一级列表
export function requestServiceListOne() {
    return request({
        url: `/workorder/v1/workOrder/serviceType/list/one`,
        method: 'get',
    })
}